import { Link } from 'react-router-dom'
import './NotFound.css'

export default function NotFound() {
    return (
        <div className="not-found-page">
            <div className="container">
                <div className="not-found-content">
                    <div className="error-code">404</div>
                    <h1>Page Not Found</h1>
                    <p>The page you're looking for doesn't exist or has been moved.</p>
                    <div className="not-found-actions">
                        <Link to="/" className="btn btn-primary btn-lg">
                            Go Home
                        </Link>
                        <Link to="/products" className="btn btn-secondary btn-lg">
                            Browse Products
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}
